export const HISTORY_DATA = ["รายเดือน", "ไตรมาส", "รายปี"];